import { AppSelector } from 'app/store'
import getDataSelector from 'core/utils/getDataSelector'
import { createSharedSelector } from 'core/utils/selectorHelpers'
import DataKeys from 'k8s/DataKeys'
import { hostedControlPlaneSelector } from '../hosted-control-plane/selectors'
import { openStackClustersSelector } from '../openstack-clusters/selectors'
import { kaapiMachineDeploymentsSelector } from '../machine-deployment/selectors'
import { kaapiMachinesSelector } from '../machines/selectors'
import { head } from 'ramda'
import { IClusterUpgradeJobSelector } from '../cluster-upgrade/model'
import { kaapiClusterUpgradeJobsByClusterSelector } from '../cluster-upgrade/selectors'

export const checkIsBYOHCluster = (cluster) =>
  cluster?.spec?.infrastructureRef?.kind === 'ByoCluster'

export const kaapiClustersSelector: AppSelector<any[]> = createSharedSelector(
  getDataSelector<DataKeys.KaapiClusters>(DataKeys.KaapiClusters),
  getDataSelector<DataKeys.KaapiClusterAddons>(DataKeys.KaapiClusterAddons),
  (kaapiClusters, kaapiClusterAddons): any[] => {
    return kaapiClusters.map((cluster) => {
      const metalLBAddonLocal = kaapiClusterAddons?.find(
        (addon) =>
          addon?.spec?.clusterID === cluster?.metadata?.name && addon?.spec?.type === 'metallb',
      )
      return {
        ...cluster,
        isBYOHCluster: checkIsBYOHCluster(cluster),
        metalLBAddon: metalLBAddonLocal || {},
        isMetalLBAddon: !!metalLBAddonLocal,
      }
    })
  },
)

//TODO:: Once upgradejob api impleneted need to refactor following logic
// export const clusterUpgradeJobsByClusterSelector = createSharedSelector(
// 	clusterUpgradeJobsSelector,
// 	(upgradeJobs) =>
// 		upgradeJobs.reduce((accum, job) => {
// 			const clusterName = job?.spec?.clusterName || ''
// 			const existingUpgradeJobs = accum[clusterName] || []
// 			// Sort by job creation timestamp in descending order
// 			const allUpgradeJobs = [...existingUpgradeJobs, job]
// 				.sort(compareByCreationTimestamp)
// 				.reverse()
// 			return assocPath([clusterName], allUpgradeJobs, accum)
// 		}, emptyObj),
// )

// export const eksVersionsSelector = createSharedSelector(
//   getDataSelector<DataKeys.EksVersions>(DataKeys.EksVersions),
//   (versions: EKSClusterVersion[]): IEksVersionsSelector[] => {
//     return versions.map((version) => ({
//       ...version,
//       deprecated: version.spec?.deprecated,
//       name: version.metadata?.name,
//     }))
//   },
// )

// export const clusterVersionsSelector = createSharedSelector(
//   getDataSelector<DataKeys.ClusterVersions>(DataKeys.ClusterVersions),
//   (rawClusterVersions): any[] => {
//     return rawClusterVersions.map((rawClusterVersion) => {
//       const latest = rawClusterVersion?.metadata?.labels?.['pmk.pf9.io/latest'] === 'true'
//       return {
//         ...rawClusterVersion,
//         latest: latest,
//         clusterCreationAllowed:
//           rawClusterVersion?.phase === 'EarlyAccess' ||
//           (rawClusterVersion?.phase === 'Active' && latest) ||
//           (rawClusterVersion?.phase === 'Deprecated' && latest),
//         // Cluster can be upgraded to this version from a lower version or patch
//         clusterUpgradePossible:
//           rawClusterVersion?.phase === 'EarlyAccess' ||
//           rawClusterVersion?.phase === 'Active' ||
//           (rawClusterVersion?.phase === 'Deprecated' && latest),
//       }
//     })
//   },
// )

// const getLatestClusterVersion = (versions, versionPropKey): string => {
//   if (isNilOrEmpty(versions)) return null
//   const sortedVersions = sortWith([descend(prop(versionPropKey))])(versions)
//   return sortedVersions[0][versionPropKey] as string
// }

// const filterClusterUpgradePossible = (clusterVersion) => clusterVersion?.clusterUpgradePossible

export const kaapiClustersOverviewSelector: AppSelector<any[]> = createSharedSelector(
  getDataSelector<DataKeys.KaapiClusters>(DataKeys.KaapiClusters),
  hostedControlPlaneSelector,
  openStackClustersSelector,
  kaapiMachineDeploymentsSelector,
  kaapiMachinesSelector,
  kaapiClusterUpgradeJobsByClusterSelector,
  getDataSelector<DataKeys.KaapiClusterAddons>(DataKeys.KaapiClusterAddons),
  //  clusterUpgradeJobsByClusterSelector,
  // clusterVersionsSelector,
  (
    kaapiClusters,
    hostedControlPlanes,
    openStackClusters,
    kaapiMachineDeployments,
    kaapiMachines,
    kaapiClusterUpgradeJobs,
    kaapiClusterAddons,
    //  clusterUpgradeJobsByCluster,
    // clusterVersions,
  ): any[] => {
    return kaapiClusters.map((cluster) => {
      const name = cluster?.metadata?.name
      // Find the hosted control plane for the cluster
      const hostedControlPlane = hostedControlPlanes?.find(
        (h) => h?.metadata?.name === cluster?.spec?.controlPlaneRef?.name,
      )
      // Find the openstack cluster for the cluster
      const openStackCluster = openStackClusters?.find(
        (h) => h?.metadata?.name === cluster?.spec?.infrastructureRef?.name,
      )
      // Find the machine deployments for the cluster
      const machineDeployments = kaapiMachineDeployments?.filter(
        (md) => md?.spec?.clusterName === cluster?.metadata?.name,
      )

      // Find the machines for the cluster
      const machines = kaapiMachines?.filter(
        (h) => h?.spec?.clusterName === cluster?.metadata?.name,
      )

      // Find the addon for the cluster
      const metalLBAddonLocal = kaapiClusterAddons?.find(
        (addon) =>
          addon?.spec?.clusterID === cluster?.metadata?.name && addon?.spec?.type === 'metallb',
      )

      // Upgrade
      const isBYOHCluster = checkIsBYOHCluster(cluster)
      const infrastructureProvider = isBYOHCluster ? 'BYOH' : 'PCD Virtualization'
      const uid = cluster?.metadata?.uid
      const upgradeJobs = kaapiClusterUpgradeJobs[name] || []
      const clusterName = cluster?.metadata?.name
      const clusterPhase = cluster?.status?.phase
      const version = hostedControlPlane?.spec?.version
      // const canUpgrade =
      //   compareVersions(version, version ? latestEksClusterVersion : latestAwsClusterVersion) === -1
      const canUpgrade = true
      //  const upgradeJobs =
      //    clusterUpgradeJobsByCluster[hostedControlPlane?.metadata?.name] || []
      // upgrade jobs are sorted in descending order by creating timestamp
      // in clusterUpgradeJobsByCluster selector. Newest job is at the top
      const recentUpgradeJob =
        upgradeJobs.length > 0 ? head<IClusterUpgradeJobSelector>(upgradeJobs) : null
      const upgradeFailed = recentUpgradeJob?.phase === 'Failed'
      const upgradeCompleted = recentUpgradeJob?.phase === 'Completed'
      const currentUpgradeJob = upgradeFailed || upgradeCompleted ? null : recentUpgradeJob
      const upgrading = !!currentUpgradeJob
      const upgradeSucessCount = 13
      const upgradeFailedCount = 12
      const strategy = machineDeployments[0]?.spec?.strategy?.type
      const maxSurgeValue = machineDeployments[0]?.spec?.strategy?.rollingUpdate?.maxSurge
      const maxSurge = 'Count'
      const maxUnavailableValue =
        machineDeployments[0]?.spec?.strategy?.rollingUpdate?.maxUnavailable
      const maxUnavailable = 'Count'
      return {
        ...cluster,
        uid,
        version,
        clusterName,
        clusterPhase,
        canUpgrade,
        recentUpgradeJob,
        upgradeFailed,
        upgradeCompleted,
        currentUpgradeJob,
        upgrading,
        upgradeSucessCount,
        upgradeFailedCount,
        strategy,
        maxSurgeValue,
        maxUnavailableValue,
        maxSurge,
        maxUnavailable,
        hostedControlPlane,
        openStackCluster,
        machineDeployments,
        machines,
        infrastructureProvider,
        upgradeJobs,
        isBYOHCluster,
        metalLBAddon: metalLBAddonLocal || {},
        isMetalLBAddon: !!metalLBAddonLocal,
      }
    })
  },
)
